export const confirmDialogConfig = {
  maxWidth: '700px',
  width: '80%',
};
